var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagLineDuotone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72799 16.137C3.18299 14.591 2.40999 13.819 2.12299 12.816C1.83499 11.813 2.08099 10.748 2.57299 8.619L2.85599 7.391C3.26899 5.599 3.47599 4.703 4.08899 4.089C4.70299 3.476 5.59899 3.269 7.39099 2.856L8.61899 2.572C10.749 2.081 11.813 1.835 12.816 2.122C13.819 2.41 14.591 3.183 16.136 4.728L17.966 6.558C20.657 9.248 22 10.592 22 12.262C22 13.933 20.655 15.277 17.966 17.966C15.277 20.657 13.933 22 12.262 22C10.592 22 9.24699 20.655 6.55799 17.966L4.72799 16.137Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.0212 10.2931C10.8023 9.51207 10.8023 8.24574 10.0212 7.46469C9.24016 6.68364 7.97383 6.68364 7.19278 7.46469C6.41173 8.24574 6.41173 9.51207 7.19278 10.2931C7.97383 11.0742 9.24016 11.0742 10.0212 10.2931Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.542 18.5L18.521 11.52",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagLineDuotone);
export default __webpack_public_path__ + "static/media/tag-line-duotone.c9ae40c3e34b29e5317f2fc034e5cfd5.svg";
export { ForwardRef as ReactComponent };